import CopyButton from "./common/CopyButton";
import DefaultLoader from "./common/DefaultLoader";
import IconButton from "./common/IconButton";
import {
  RefreshRounded as RefreshIcon,
  VisibilityRounded as VisibleIcon,
  VisibilityOffRounded as HiddenIcon,
} from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { fetchAuthSession } from "aws-amplify/auth";
import * as logger from "common/logger";
import Component from "components/Component";
import Dashboard from "components/layout/Dashboard";
import DashboardContent from "components/layout/DashboardContent";
import { useState, useEffect } from "react";

const forceTokenRefresh = async () => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    return session.tokens?.accessToken?.toString();
  } catch (error) {
    throw new Error("Could not refresh token:\n" + error);
  }
};

const TokenApp = (props) => {
  const [token, setToken] = useState("Empty");
  const [isTokenLoading, setTokenLoading] = useState(false);
  const [isTokenHidden, setTokenHidden] = useState(true);
  const refreshToken = () => {
    setTokenLoading(true);
    forceTokenRefresh()
      .then((token) => {
        setToken(token);
        setTokenLoading(false);
      })
      .catch(logger.exception);
  };
  const getRedactedToken = (token) => {
    const charsVisible = 4;
    const prefix = "░".repeat(token.length - charsVisible);
    const suffix = token.substring(token.length - charsVisible, token.length);
    return prefix + suffix;
  };
  useEffect(() => {
    refreshToken();
  }, []);
  const displayedToken = isTokenLoading
    ? ""
    : isTokenHidden
    ? getRedactedToken(token)
    : token;
  return (
    <div className={"app"}>
      <Dashboard>
        <DashboardContent>
          <Component
            title={"Access Token"}
            subtitle={
              "Tokens allow API access to your Marmalade data without using the app. Please note that anyone you share this token with will have full access to your data."
            }
            options={
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"flex-end"}
                gap={1}
              >
                <IconButton
                  icon={isTokenHidden ? HiddenIcon : VisibleIcon}
                  onClick={() => setTokenHidden(!isTokenHidden)}
                  tooltip={"Show / Hide Token"}
                />
                <IconButton
                  icon={RefreshIcon}
                  onClick={() => refreshToken()}
                  tooltip={"Refresh Token"}
                />
                <CopyButton content={token} tooltip={"Copy Token"} />
              </Stack>
            }
          >
            {isTokenLoading ? (
              <DefaultLoader
                style={{
                  width: "200px",
                  height: "264px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                size={60}
              />
            ) : (
              <Typography
                sx={{
                  fontFamily: "monospace",
                  wordWrap: "break-word",
                  wordBreak: "break-all",
                }}
                className={"fade-in-slow"}
              >
                {displayedToken}
              </Typography>
            )}
          </Component>
        </DashboardContent>
      </Dashboard>
    </div>
  );
};

export default TokenApp;
